import { getLocale } from '@common'
import { GetServerSidePropsContext } from 'next'
import Head from 'next/head'
import { useTranslations } from 'next-intl'

import ErrorLayout from '@/features/ErrorLayout'
import { errorKeys } from '@/localization/utils'
import { getCommonMessages } from '@/ssr/wrapper'

import styles from '../components/NotFound.module.scss'

function Error({ statusCode }: { statusCode?: number }) {
  const t = useTranslations()

  const { title, description } = errorKeys(statusCode || -1)
  return (
    <ErrorLayout image="airport" withGradient>
      <Head>
        <title>{t('route_404')}</title>
      </Head>
      <div className={styles.Content}>
        <h1 className={styles.Title} data-cy="error-title">
          {statusCode}
          <br />
          {t(title)}
        </h1>
        <p className={styles.Description}>{t(description)}</p>
      </div>
    </ErrorLayout>
  )
}

export default Error

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const messages = await getCommonMessages(getLocale(ctx))
  return {
    props: {
      messages,
      statusCode: ctx.res.statusCode,
    },
  }
}
